module.exports = __webpack_public_path__ + "img/742.f2d34da8.jpg";